export default __webpack_public_path__ + "static/sunburst-c8e1cf806801b5e1d1d9161109aef518.png";